import { render } from "./forgotPassword.vue?vue&type=template&id=289bf468"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/auth/forgotPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "289bf468"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('289bf468', __exports__)) {
    console.log('reload')
    api.reload('289bf468', __exports__)
  }
  
  module.hot.accept("./forgotPassword.vue?vue&type=template&id=289bf468", () => {
    console.log('re-render')
    api.rerender('289bf468', render)
  })

}


export default __exports__